import React from 'react';
import { useCursor } from '../context/CursorContext';

export const CustomCursor = () => {
  const { mousePos, label, isTouch } = useCursor();

  if (isTouch) return null;

  return (
    <>
      <div
        className="fixed w-3 h-3 bg-green-500 rounded-full pointer-events-none z-[99999]"
        style={{
          left: mousePos.x - 6,
          top: mousePos.y - 6,
          boxShadow: label
            ? '0 0 15px rgba(34, 197, 94, 0.6)'
            : '0 0 8px rgba(34, 197, 94, 0.4)',
          transition: 'box-shadow 0.2s ease',
        }}
      />
      {label && (
        <div
          className="fixed bg-green-500 text-black px-2 py-1 pointer-events-none z-[99999]"
          style={{
            left: mousePos.x + 12,
            top: mousePos.y + 12,
          }}
        >
          <span className="text-[10px] font-bold uppercase tracking-wider whitespace-nowrap">
            {label}
          </span>
        </div>
      )}
    </>
  );
};
